import List from '@mui/material/List';
import { useFormContext } from 'react-hook-form';
import type { ConfigType } from '@repo/api/endpoints/merchant';

import type { LoanFormInputFields } from '@/components/loan-form/schema/loan-form.schema';
import { useMainHubStoreAvailableResponseDataState } from '@/store/main-hub.store';
import { VIEW_TYPE, ViewType, type ViewTypes } from '@/store/view.type';

import { SingleRecipientDetail } from './single-recipient-detail';

interface RecipientDetailsListProps {
  config: ConfigType;
  viewType?: Exclude<ViewType, ViewTypes['APP_LOADING'] | ViewTypes['SERVICE_NOT_AVAILABLE']>;
}

export function RecipientDetailsList({ config, viewType }: RecipientDetailsListProps) {
  const formContext = useFormContext<LoanFormInputFields>();
  const {
    merchantResponseData: { data },
  } = useMainHubStoreAvailableResponseDataState(viewType ?? VIEW_TYPE.LOAN_FORM_VIEW);

  return (
    <List>
      {config.parameters.map((parameter, index) => (
        <SingleRecipientDetail
          data={data}
          formContext={formContext}
          index={index}
          key={parameter.name}
          parameter={parameter}
        />
      ))}
    </List>
  );
}
